import React from "react";
import AdminContainer from "../../components/ui/AdminContainer";
import UserSearchForm from "./UserSearchForm";

const UserProfileForm = () => {
    return (
        <AdminContainer>
            <UserSearchForm />
        </AdminContainer>
    );
};

export default UserProfileForm;
